import React from 'react';

import { CampaignStatus } from '@/services/ws-digital/src/main/resources/rest-api';
import { CampaignPositionType } from '@/services/ws-orders/src/main/resources/rest-api';
import { useIdentityRoles } from '@/js/libs/use-auth';

type UseDefaultPositionTypeStatus = (positionType?: CampaignPositionType) => { defaultPositionTypeStatus: CampaignStatus };

export const useDefaultPositionTypeStatus: UseDefaultPositionTypeStatus = (positionType) => {
  const { BOOK_CAMPAIGNS } = useIdentityRoles();

  return React.useMemo(
    () => ({
      defaultPositionTypeStatus: !BOOK_CAMPAIGNS
        ? CampaignStatus.ALL
        : positionType === CampaignPositionType.PRINT
          ? CampaignStatus.BOOKED
          : CampaignStatus.RUNNING,
    }),
    [BOOK_CAMPAIGNS, positionType],
  );
};
